<template>
  <div class="user-profile--programs-list">
    <v-row>
      <v-col cols="12" sm="12" md="12" class="d-flex justify-end">
        <v-btn
          class="bg-primary-gradient primary mr-3"
          :to="{ name: 'user.program-history.completed' }"
        >
          <v-icon class="mr-3"> {{ icons.check }} </v-icon>
          Completed
        </v-btn>
        <v-btn
          v-if="hasMembership"
          class="bg-primary-gradient primary mr-3"
          :loading="correctingValidUntil"
          @click="correctValidUntil"
        >
          <v-icon class="mr-3"> {{ icons.refresh }} </v-icon>
          Update End Date
        </v-btn>
        <v-btn
          class="bg-primary-gradient primary"
          @click="addNewPrgoram = true"
        >
          <v-icon class="mr-3"> {{ icons.add }} </v-icon>
          Assign New Program
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <program-history-table
          :programs="programs"
          :loading="loading"
          @goTo="goTo"
        />
      </v-col>
    </v-row>

    <assign-new-program v-model="addNewPrgoram" @refresh-list="fetchPrograms" />

    <v-toast ref="toast" />
  </div>
</template>

<script>
import AssignNewProgram from '@/components/modals/users/AssignNewProgram'
import ProgramHistoryTable from '../components/ProgramHistoryTable'
import VToast from '@/components/elements/Toast'

import { mdiPlus, mdiRefresh, mdiCheck } from '@mdi/js'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'UserProgramList',

  components: {
    AssignNewProgram,
    ProgramHistoryTable,
    VToast,
  },

  data() {
    return {
      loading: false,
      addNewPrgoram: false,
      correctingValidUntil: false,
      icons: {
        add: mdiPlus,
        refresh: mdiRefresh,
        check: mdiCheck,
      },
    }
  },

  created() {
    this.fetchPrograms()
  },

  destroyed() {
    this.clearPrograms()
  },

  computed: {
    ...mapState({
      programs: (state) => state.userProfile.programs,
      user: (state) => state.users.selectedUser,
    }),

    hasMembership() {
      return this.user && this.user.current_user_subscription
    },
  },

  methods: {
    ...mapActions({ getPrograms: 'userProfile/getPrograms' }),
    ...mapMutations({ clearPrograms: 'userProfile/clearPrograms' }),

    async fetchPrograms() {
      this.loading = true

      await this.getPrograms(this.$route.params.id)

      await this.$sleep()

      this.loading = false
    },

    goTo(programId) {
      this.$router.push({
        name: 'user.program-history.details',
        params: { programId },
      })
    },

    async correctValidUntil() {
      this.correctingValidUntil = true

      try {
        await this.$api.post(
          `users/${this.$route.params.id}/correct-valid-until`
        )

        this.$refs.toast.open({
          color: 'success',
          message: 'Valid until dates have been corrected successfully.',
        })

        // Refresh the programs list
        await this.fetchPrograms()
      } catch (error) {
        this.$refs.toast.open({
          color: 'error',
          message:
            error.response?.data?.message ||
            'Failed to correct valid until dates.',
        })
      } finally {
        this.correctingValidUntil = false
      }
    },
  },
}
</script>
